import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    standalone: true,
    name: "fileSizeByteToMb",
})
export class FileSizeByteToMbPipe implements PipeTransform {
    transform(size: number) {
        // treat size as positive number
        // size = Math.abs(size);
        let sizes = [" Bytes", " KB", " MB", " GB", " TB", " PB", " EB", " ZB", " YB"];
        for (let i = 1; i < sizes.length; i++) {
            if (size < Math.pow(1024, i)) return Math.round((size / Math.pow(1024, i - 1)) * 100) / 100 + sizes[i - 1];
        }
        return size;
    }
}
